"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const SelectionType = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "M9.632 9a4 4 0 100-8 4 4 0 000 8z", opacity: 0.6 }),
    /* @__PURE__ */ React.createElement("path", { d: "M17.632 13h-.26a2 2 0 00-2.86-.66 2 2 0 00-3.88.66V5a1 1 0 00-2 0v10c0 1-1 1-1.69-.29s-1.31-2.71-2.31-2.48c-1.53.37 0 1.77 1.61 5.37a20.91 20.91 0 003.39 5.4h7a11 11 0 003-7v-1a2 2 0 00-2-2z" })
  );
};
export default SelectionType;
